type PlanzoneError = {
  errors: { errorCode: string; errorMessage: string | null }[];
};

function extractFlags(error: unknown): string[] {
  if (
    typeof error === "object" &&
    error !== null &&
    "errors" in error &&
    Array.isArray(error.errors)
  ) {
    return error.errors.map((e) => {
      return typeof e === "object" &&
        e !== null &&
        "errorCode" in e &&
        typeof e.errorCode === "string"
        ? e.errorCode
        : "";
    });
  }

  return [];
}

function mapFlags(
  mappedFlags: { [key: string]: string },
  extractedFlags: string[],
): { [key: string]: boolean } {
  const hasFlag = (flag: string) => !!extractedFlags.find((f) => f === flag);

  return Object.entries(mappedFlags).reduce(
    (map, [errorFlag, flag]) =>
      hasFlag(flag) ? { ...map, [errorFlag]: true } : map,
    {},
  );
}

function mapError(error: unknown, mappedFlags: { [key: string]: string }) {
  return mapFlags(mappedFlags, extractFlags(error));
}

export { mapError };
